var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('peek-form',{attrs:{"title":_vm.title,"footer":false}},[(!_vm.provider)?_c('provider-list'):_c('provider-view',{attrs:{"provider":_vm.provider}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }